const inProgress = new Map();
const done = new Set();

/**
 * Async load script
 * @param {string} src 
 * @returns {Promise<void>}
 */
export default function loadScript(src, name = '',  type=null, attributes = null) {
   name = name || src;

   if (done.has(name)) return Promise.resolve();
   if (inProgress.has(name)) return inProgress.get(name);

   const loadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');

      if (type){
         script.setAttribute('type', type);
      }

   if (attributes) {
      for (let i in attributes) {
         if (Object.prototype.hasOwnProperty.call(attributes, i)) {
            script.setAttribute(i, attributes[i]);
         }
      }
   }

      script.onload = () => {
         inProgress.delete(name);
         done.add(name);
         resolve();
      };

      script.onerror = () => {
         inProgress.delete(name);
         reject(`Couldn't load script: ${name}`);
      };

      script.src = src;
      document.body.appendChild(script);
   });

   inProgress.set(name, loadPromise);
   return loadPromise;
}

/**
 * Check if the script is completely loaded
 * @param {string} src
 * @returns {boolean}
 */
export function isLoadedScript(name) {
   return done.has(name);
}

/** 
 * Check if the script is loading now  
 * @param {string} src
 * @returns {boolean}
 */
export function isScriptInProgress(src) {
   return inProgress.has(src);
}